import styles from '../../styles/Loader.module.css'

const ClientInformationSkeleton = ({boxCount}) => {
    return(
        <div className={styles.skeletonClientInformation}>
            <div className={styles.skeletonClientInformationTitle}></div>
            {Array.from({length: boxCount},(_,index) => (
                <div key={index} className={styles.skeletonClientInformationBox}></div>
            ))}
            <div className={styles.skeletonClientInformationReturn}></div>
        </div>
    )
}

export default ClientInformationSkeleton;